import { store } from "../../App"

export const handleLoading = () => {
    store.dispatch({ type: 'HANDLE_LOADING' })
}